/*
 * @Description: 销售订单有关语言包
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
export default {
  销售订单: 'Sales Order',
  实缴信息: 'Paid-in Information',
  新增订单: 'New Order',
  天: 'Days',
  查看: 'View',
  转移: 'Transfer',
  基础字段: 'Basic Fields',
  转移订单: 'Transfer Order',
  编辑销售订单: 'Edit Sales Order',
  新增销售订单: 'Add Sales Order',
  销售订单管理: 'Sales Order',
  重置: 'Reset',
  提交: 'Submit',
  收起: 'Collapse',
  展开: 'Expand',
  提交并按明细拆分: 'Submit and Split by Details',
  基本信息: 'Basic Information',
  系统信息: 'System Information',
  订单明细: 'Order Details',
  添加报价单明细: 'Add Quotation Details',
  添加合同明细: 'Add Contract Details',
  数据加载中: 'Data loading',
  操作失败: 'Operation Failed',
  获取数据失败: 'Failed to obtain data',
  编辑订单明细: 'Edit Order Details',
  添加订单明细: 'Add Order Details',
  请选择报价单: 'Please select a quotation',
  请选择销售合同: 'Please select a sales contract',
  添加明细: 'Add Details',
  编辑: 'Edit',
  复制: 'Copy',
  删除: 'Delete',
  加载中: 'Loading',
  详细信息: 'Details',
  审批记录: 'Approval Records',
  暂无此销售订单查看权限: 'No permission to view this sales order',
  关闭: 'Close',
  取消: 'Cancel',
  确定: 'Confirm',
  选择价格: 'Select Price',
  已过期价格不可选: 'Expired price not selectable',
  至: 'To',
  标准价格: 'Standard price',
  币种: 'Currency',
  时长单位: 'Duration Unit',
  规格单位: 'Specification Units',
  有效期: 'Validity',
  请选择产品名称: 'Please choose a product name',
  操作: 'Operation',
  提交成功: 'Submission Successful',
  报价单是必填项: 'Quotation is required',
  PO单附件是必填项: 'Attachment to PO is mandatory',
  审批编号: 'Approval Number',
  审批状态: 'Approval Status',
  拒绝理由: 'Reason for rejection',
  最后审批人: 'Final Approver',
  最后审批时间: 'Time of Final Approval',
  发起人: 'Initiator',
  发起时间: 'Initiation Time'
};
